const getComputedStyleOptimized = (() => {
  let computedStyle: CSSStyleDeclaration;

  return (elem: Element) => {
    if (!computedStyle) {
      computedStyle = getComputedStyle(elem);
    }

    return computedStyle;
  };
})();

/**
 * Get a property based on the token
 * e.g: color: var(--dt-colors-charts-categorical-color-02-default, hsl(270, 97%, 13%))'
 *      newColor: --dt-colors-charts-categorical-color-02-default
 *      return value: hsl(270, 97%, 13%) (the color based on the theme)
 * @param token - Design token string
 * @returns the property computed style
 */
export const getTokenComputedStyle = (token: string): string => {
  if (token.indexOf('var') === -1) {
    return token;
  }
  const firstParenthesis = token.indexOf('(');
  const firstComma = token.indexOf(',');
  const property = token.substring(firstParenthesis + 1, firstComma);
  const computedStyle = getComputedStyleOptimized(document.documentElement);

  return computedStyle.getPropertyValue(property);
};
